import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { Dialog, Paper, Grid, withStyles } from '@material-ui/core';
import TypicalProblemForm, {types} from './TypicalProblemForm'
import * as Yup from "yup";
import { BackButton } from '../../sc-utilities';
import * as actions from './store/typicalProblemActions';
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    progress: {
        width: `398px`,
        height: "400px"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }

});

const TypicalProblemCreate = props => {
    const { classes, activeCustomer, translations, onFetchGrades, onFetchGradingCategories, onCreateTypicalProblem, permissions } = props;

    const [data, setData] = useState({
        grades: [],
        gradingCategories: [],
        loadingData: true,
        types: [],
        key: ''
    });

    useEffect(() => {
        const fetchData = async () => {
            let gradeData = await onFetchGrades({ ActiveCustomerID: activeCustomer });
            let gradingCategoryData = await onFetchGradingCategories({ ActiveCustomerID: activeCustomer });


            setData({
                grades: gradeData,
                gradingCategories: gradingCategoryData,
                types: types,
                loadingData: false
            });
        };
        fetchData();
        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    if (data.grades.length === 0) {
        data.grades.push({ value: "grades_none", displayValue: "None" });
    }

    if (data.gradingCategories.length === 0) {
        data.gradingCategories.push({ value: "gradingCategories_none", displayValue: "None" });
    }

    if (data.types.length === 0) {
        data.types.push({ value: "types_none", displayValue: "None" });
    }

    const handleSubmit = async data => {
        let objestToSend = {...data};
        if (objestToSend["GradeID"] === "grades_none") {
            objestToSend["GradeID"] = null;
        }
        if (objestToSend["GradingCategoryID"] === "gradingCategories_none") {
            objestToSend["GradingCategoryID"] = null;
        }
        if (objestToSend["Key"] === "" || objestToSend["CustomerID"] === 'custom') {
            objestToSend["Key"] = null;
        }
        objestToSend["CustomerID"] === "system" ? objestToSend["CustomerID"] = null    :   objestToSend["CustomerID"] = activeCustomer;
        let result = await onCreateTypicalProblem({ ...objestToSend, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };



    let initialValues = {
        Name: '',
        LongName: '',
        Code: '',
        GradeID: data.grades && data.grades.length > 0 ? data.grades[0].value : '',
        GradingCategoryID: data.gradingCategories && data.gradingCategories.length > 0 ? String(data.gradingCategories[0].value) : '',
        CustomerID: data.types && data.types.length > 0 ? data.types[0].value : '',
        Key: ''
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            LongName: Yup.string().required("Required"),
            Code: Yup.string().required("Required"),
            GradeID: Yup.string().required("Required"),
            GradingCategoryID: Yup.string().required("Required"),
            CustomerID: Yup.string().required("Required"),
            Key: Yup.string().when("CustomerID", {
                is: "system",
                then: Yup.string().required()
            })
        },
        FormTitle: translations['create_typical_problem'] || "Create typical problem",
        ButtonSubmit: {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        }
    };

    return (
        <Paper className={classes.root} >
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data.loadingData}
                PaperProps={{
                    classes: {
                        root: classes.paper
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    {!data.loadingData ?
                        <TypicalProblemForm
                            formSettings={formSettings}
                            initialValues={initialValues}
                            grades={data.grades}
                            handleSubmit={handleSubmit}
                            gradingCategories={data.gradingCategories}
                            create={true}
                            translations={translations}
                            types={data.types}
                            permissions={permissions}
                            CustomerIDPreviousState={''}
                        />
                        : null}
                </Grid>
            </Grid>
        </Paper>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateTypicalProblem: typicalProblem => dispatch(actions.createTypicalProblem(typicalProblem)),
        onFetchGrades: (id) => dispatch(actions.fetchGrades(id)),
        onFetchGradingCategories: (id) => dispatch(actions.fetchGradingCategories(id))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TypicalProblemCreate));
